import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from "@mui/material";
import { useQuery } from "react-query";

import { DataSection } from "@/components/DataSection";
import { getFollowUp } from "@/services/followUp";
import { CircularLoading } from "@/components/CircularLoading";
import { formatDate } from "@/formatter";
import { getFollowedAtColor, getUpdatedByDetail } from "@/utils";

import { FollowUpChangeLogTimeline } from "./FollowUpChangeLogTimeline";

import type { FollowUpChangeLog } from "@/models";

const QUERY_KEY = "getFollowUp";

export type FollowUpDetailProps = {
  id: string;
};

export function FollowUpDetail({ id }: FollowUpDetailProps) {
  const { data, isFetching } = useQuery(QUERY_KEY, () => getFollowUp(id));

  const updateByDetail = getUpdatedByDetail(data?.updatedBy, data?.updatedAt);

  if (isFetching || !data)
    return (
      <Card>
        <CircularLoading height={480} />
      </Card>
    );

  const {
    no,
    followedAt,
    remark,
    reason,
    summary,
    updatedAt,
    updatedBy,
    trainingFollowUpChangeLogs,
    memberTraining: training,
    isLastFollowUp,
  } = data;

  const currentItem: FollowUpChangeLog = {
    createdAt: updatedAt,
    updatedBy,
    followedAt,
    remark,
    reason,
  };
  const changeLogs = [currentItem, ...trainingFollowUpChangeLogs];

  const followedAtColor = getFollowedAtColor({
    status: training.status,
    followedAt,
    isLastFollowUp,
  });

  const columns = [
    [
      {
        data: [
          {
            label: "วันที่",
            value: (
              <Typography variant="body2" color={followedAtColor}>
                {formatDate(followedAt)}
              </Typography>
            ),
            key: `${id} ${followedAt.toISO()}`,
          },
          {
            label: "หมายเหตุ",
            value: remark || "-",
          },
          {
            label: "ผลการติดตาม",
            value: summary || "-",
          },
        ],
      },
    ],
  ];

  return (
    <Stack gap={3}>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              gap={3}
              alignItems="center"
            >
              <Typography variant="h6">{`ติดตามผลครั้งที่ ${no}`}</Typography>
              <Typography variant="body2" color="text.secondary">
                {updateByDetail}
              </Typography>
            </Stack>
          }
        />
        <CardContent>
          <DataSection columns={columns} />
        </CardContent>
      </Card>
      <FollowUpChangeLogTimeline changeLogs={changeLogs} />
    </Stack>
  );
}
